export default function Categories() {
    return (
        <div>kategorie</div>
    )
}